export enum PagePathname {
  dashboard = '/dashboard',
  alleBerater = '/all-agents',
  beraterErstellen = '/create-agent',
  beraterBearbeiten = '/agent/:number',
  logout = '/logout',

  // Berichte
  berichte = '/berichte',
  karte = '/berichte/map',
  leistungReport = '/berichte/servicesReport',

  // Buchhaltung
  buchhaltung = '/buchhaltung',
  alleBelege = '/buchhaltung/finance',
  belege = '/buchhaltung/receipt-edit/:number',
  belegeErstellen = '/buchhaltung/receipt-create',
  abschluss = '/buchhaltung/montlyAccounting',
  shopifyBelege = '/buchhaltung/import-shop-receipts',

  // Einstellung
  einstellung = '/einstellung',
  buchungskonten = '/einstellung/bookingAccount',
  ränge = '/einstellung/ranks',
  levels = '/einstellung/levels',
  benutzer = '/einstellung/users',
  marken = '/einstellung/branchOffice',
  leistungen = '/einstellung/services',
  steuern = '/einstellung/tax',
  länder = '/einstellung/coutrys',
  vertragsarten = '/einstellung/contractTyps',
  systemdienstleister = '/einstellung/systemdienstleister',
  systemdienstleisterNeu = '/einstellung/systemdienstleister/neu',
  systemdienstleisterBearbeiten = '/einstellung/systemdienstleister/:id',
  briefvorlagen = '/einstellung/briefvorlagen',
  briefvorlagenNeu = '/einstellung/briefvorlagen/neu',
  briefvorlagenBearbeiten = '/einstellung/briefvorlagen/:id',
  adminPanel = '/einstellung/admin-panel',
}
export default PagePathname;
